module.exports = __webpack_public_path__ + "img/trafic-sq.112d937c.svg";